// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"740111b2","977":"bce4e624"}[chunkId] + ".chunk.js";
};